import styled from "styled-components";
import { colors, types } from "../../../libs";

export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: ${colors.background.lightBlack};
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
  width: 100%;
`;
export const LeftSection = styled.div`
  flex: 1;
  min-width: 0;
`;
export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const Title = styled.div`
  ${types.body.normal};
  font-weight: bold;
  color: ${colors.text.white};
`;
export const Badge = styled.span<{ $active?: boolean }>`
  ${types.body.small};
  color: ${({ $active }) => ($active ? colors.text.green : colors.text.gray)};
  background: ${colors.background.lightGrey};
  padding: 3px 8px;
  border-radius: 12px;
`;
export const Subtitle = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 5px;
`;
export const Metrics = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
  margin-right: 20px;
`;
export const Metric = styled.div`
  text-align: center;
  min-width: 75px;
`;
export const MetricValue = styled.div`
  ${types.body.normal};
  color: ${colors.text.white};
  font-weight: 600;
`;
export const MetricLabel = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
`;
export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const EditButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 0;
  background: ${colors.background.lightGrey};
  color: ${colors.text.white};
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: ${colors.text.green};
  }
`;
export const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 60px;
  height: 32px;
  background: ${colors.background.lightGrey};
  border-radius: 50px;
  padding: 2px;
`;
export const ControlIndicator = styled.div<{ $isEnabled: boolean }>`
  position: absolute;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${({ $isEnabled }) => ($isEnabled ? colors.background.green : colors.background.red)};
  transition: transform 0.3s;
  transform: translateX(${({ $isEnabled }) => ($isEnabled ? "28px" : "0")});
  z-index: 1;
`;
export const ControlButton = styled.button<{ $isActive: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 0;
  background: transparent;
  color: ${({ $isActive }) => ($isActive ? colors.text.black : colors.text.white)};
  cursor: pointer;
  z-index: 2;
`;
